export default "__VITE_ASSET__a35a0e60__"